import { Component, ChangeDetectionStrategy } from '@angular/core';

import { LoaderComponent } from '../loader/loader.component';
import { LoaderService } from '../../../@services/front/loader.service';

@Component({
  selector: 'vw-app-loader',
  imports: [LoaderComponent],
  templateUrl: './app-loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app-loader.component.scss']
})
export class AppLoaderComponent {
  showLoader: boolean = false;
  constructor(private loaderService: LoaderService) {
    loaderService.loaderSubject.subscribe((res) => {
      this.showLoader = res;
    })
  }
}
